import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Alert,
  CircularProgress,
  Link,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import apiService from "../services/api";
import { AuthScreenShell, AuthCard, AuthCardHeader } from "../components/auth";
import { productBrand } from "../productBrand";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    const trimmed = email.trim().toLowerCase();
    if (!trimmed) {
      setError("Ingresa tu email");
      return;
    }
    setLoading(true);
    try {
      await apiService.forgotPassword(trimmed);
      setDone(true);
    } catch (err: any) {
      const msg =
        err.response?.data?.message ||
        (typeof err?.message === "string" && err.message === "Network Error"
          ? "No se pudo conectar con el servidor. Revisa tu conexión o la URL del API."
          : typeof err?.message === "string"
            ? err.message
            : null);
      setError(msg || "No se pudo enviar el correo. Intenta más tarde.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthScreenShell>
      <AuthCard>
        <AuthCardHeader
          title="Recuperar contraseña"
          titleSx={{ fontFamily: productBrand.fontFamily }}
          subtitle={
            done
              ? undefined
              : "Te enviaremos un enlace para elegir una nueva contraseña."
          }
        />
        {done ? (
          <Alert severity="success" sx={{ mb: 2 }}>
            Si existe una cuenta con ese email, recibirás un enlace para restablecer tu
            contraseña.
          </Alert>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              autoComplete="email"
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              sx={{ mt: 2 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : "Enviar enlace"}
            </Button>
          </form>
        )}
        <Typography variant="body2" sx={{ mt: 3, textAlign: "center" }}>
          <Link component={RouterLink} to="/auth">
            Volver
          </Link>
        </Typography>
      </AuthCard>
    </AuthScreenShell>
  );
};

export default ForgotPassword;
